import buildLeadsFilterUrl from 'utils/buildLeadsFilterUrl';

interface NavigationHandlerProps {
  onActionButtonClick: (url: string) => void;
  filters: {
    startDate: Date;
    endDate: Date;
    businessUnitId: number;
    sources?: string[];
    brands?: string[];
    campaignIds?: string[];
  };
  additionalFilters?: Record<string, boolean | string[]>;
}

const createNavigationHandler = ({ onActionButtonClick, filters, additionalFilters = {} }: NavigationHandlerProps) => {
  if (!onActionButtonClick || !filters) return undefined;

  return () => {
    const url = buildLeadsFilterUrl({
      ...filters,
      ...additionalFilters,
      viewMode: 'table',
    });
    onActionButtonClick(url);
  };
};

export default createNavigationHandler;
